import React, {createElement as el, forwardRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ViziaComponent from '../containers/ViziaComponent';
import './SlideLayout.css';

const ViziaComponentWrapper = (props) => (
  <div className="SlideLayout__item">
    <ViziaComponent {...props} />
  </div>
);

function drawRows(rows, componentOrder, componentProps = {}) {
  return rows.map((row, i) => {
    return el(
      'div',
      {
        key: i,
        className: `vl-flex-row vl-flex-${row.height || 1}`
      },
      row.columns && drawColumns(row.columns, componentOrder, componentProps)
    );
  });
}

function drawColumns(columns, componentOrder, componentProps = {}) {
  return columns.map((column, i) => {
    let child;

    if (column.rows) {
      child = drawRows(column.rows, componentOrder, componentProps);
    } else if (componentOrder.length) {
      let props;
      if (componentProps.Component === ViziaComponent) {
        props = componentProps;
      }
      child = el(ViziaComponentWrapper, Object.assign({}, props, {id: componentOrder.shift()}));
    }

    return el(
      'div',
      {
        key: i,
        className: `vl-flex-column vl-flex-${column.width || 1}`
      },
      child
    );
  });
}

/* eslint-disable-next-line react/display-name  */
const SlideLayout = forwardRef(({
  Component = ViziaComponent,
  layout = {},
  layout_id,
  component_order = [],
  layout_is_flipped_horizontally = false,
  layout_is_flipped_vertically = false,
  loadIframes = false,
  preloadState,
  className = 'SlideLayout'
}, ref) => {
  const props = {
    'layout-id': layout_id,
    className: classNames(className, {
      [`${className}--one-component`]: component_order.length === 1,
      [`${className}--flip-horizontally`]: layout_is_flipped_horizontally,
      [`${className}--flip-vertically`]: layout_is_flipped_vertically
    }),
    ref
  };
  return el('div', props, drawColumns([layout], component_order.slice(), {Component, preloadState, loadIframes}));
});

SlideLayout.propTypes = {
  className: PropTypes.string,
  loadIframes: PropTypes.bool,
  Component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  component_order: PropTypes.array,
  layout: PropTypes.object.isRequired,
  layout_id: PropTypes.string,
  layout_is_flipped_horizontally: PropTypes.bool,
  layout_is_flipped_vertically: PropTypes.bool,
};

export default SlideLayout;
